import React from 'react';

export const TsuCountryModal = {
  title: 'Source Country',
  body: (
    <div>
      <p>
        The Country where the tsunami source occurred (For example enter: Japan or Russia).
      </p>
    </div>
  ),
};
